module.exports = __webpack_public_path__ + "static/media/3S.a5a385d2.svg";